//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["ruleInstance","predictView","predictPlane"],"SetPredictionOptions",{},3,0],[["ruleInstance","numOfObjects"],"GetOutput",{R_:{objects:"NXObject[]"}},1,0],[["ruleInstance","context","numOfObjects"],"GetContextOutput",{R_:{objects:"NXObject[]"}},2,0]],[]];
SPLM.MBD.RuleManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.RuleManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;